'use effect';
import { useEffect, useState } from 'react';

type DigitProps = {
  digit: string;
  digitSize: number;
  className?: string;
  hasShadow?: boolean;
};

const Digit = ({ digit, hasShadow, digitSize, className }: DigitProps) => {
  return (
    <div
      className='relative overflow-hidden text-center'
      style={{ height: digitSize, width: digitSize * 0.55 }}
    >
      <div
        className='absolute left-0 transition-transform duration-300 ease-in-out'
        style={{
          transform: `translateY(-${parseInt(digit) * digitSize}px)`,
        }}
      >
        {[...Array(10).keys()].map((n) => (
          <div
            key={n}
            className='relative font-bold'
            style={{
              height: digitSize,
              lineHeight: `${digitSize}px`,
              fontSize: digitSize * 0.8,
            }}
          >
            {hasShadow && (
              <span
                className='absolute inset-0 font-bold text-black opacity-30 blur-[1px]'
                style={{ transform: 'translateY(2px)', zIndex: 0 }}
              >
                {n}
              </span>
            )}

            <span className='relative z-10'>{n}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export const RollingCounter = ({
  value,
  digitSize = 40,
  className,
  hasShadow = true,
}: {
  value: number;
  digitSize?: number;
  className?: string;
  hasShadow?: boolean;
}) => {
  const [digits, setDigits] = useState<string[]>([]);

  useEffect(() => {
    const strDigits = value.toString().padStart(1, '0').split('');
    setDigits(strDigits);
  }, [value]);

  return (
    <div className='flex space-x-[2px]'>
      {digits.map((digit, index) => (
        <Digit
          key={index}
          hasShadow={hasShadow}
          digit={digit}
          className={className}
          digitSize={digitSize}
        />
      ))}
    </div>
  );
};
